export const IconSort = (props) => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 8H4C3.39987 8 3 7.60013 3 7C3 6.39987 3.39987 6 4 6H16C16.6001 6 17 6.39987 17 7C17 7.60013 16.6001 8 16 8Z"
      fill="black"
    />
    <mask
      id="mask0_3655_34272"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="14"
    >
      <path d="M20 0H0V14H20V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_3655_34272)">
      <path
        d="M13 14H7C6.39987 14 6 13.6001 6 13C6 12.3999 6.39987 12 7 12H13C13.6001 12 14 12.3999 14 13C14 13.6001 13.6001 14 13 14Z"
        fill="black"
      />
    </g>
    <mask
      id="mask1_3655_34272"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="14"
    >
      <path d="M20 0H0V14H20V0Z" fill="white" />
    </mask>
    <g mask="url(#mask1_3655_34272)">
      <path
        d="M19 2H1C0.399875 2 0 1.60013 0 1C0 0.399875 0.399875 0 1 0H19C19.6001 0 20 0.399875 20 1C20 1.60013 19.6001 2 19 2Z"
        fill="black"
      />
    </g>
  </svg>
);
